// scenePreviewSync — pure sync/highlight decision for AnimatorPanel's
// narration preview (bulk-infographic-animation spec, Task C). Mirrors the
// Visor's playhead model (_visor/managers/AudioScheduler.js and VisorBox's
// startFrame<=frame<endFrame gate) but in seconds, since preflight already
// gives per-image timing in seconds instead of frames.

// The scene playhead is soundStartTime + audio.currentTime (see
// _visor/containers/VisorApp.jsx's soundList playhead checks, e.g.
// `playhead >= sound.startTime && playhead < soundEndSec(sound)`).
// AnimatorPanel's GET scene-audios payload does not expose that per-entry
// startTime offset (verified against the live payload) -- callers pass 0,
// correct as long as exactly one narration entry is used per scene, which is
// both the observed real-world shape and the same simplification
// ImageAnimatorModal.jsx already makes when it picks a single narration
// entry for its own preview text.
export function computeScenePlayhead(soundStartTime, audioCurrentTime) {
  return (Number(soundStartTime) || 0) + (Number(audioCurrentTime) || 0);
}

// Which card (boxId) is "on screen" at a given scene playhead. A card
// matches when startSec <= playhead < endSec; null start/end (preflight's
// "no explicit timing" case) is treated as -Infinity/+Infinity ("visible for
// the whole scene"), so it still loses to any dated card whose window has
// opened.
//
// Overlap rule: consecutive images cross-fade (~1s overlap in real data), so
// more than one card can match -- the latest-starting match wins (the
// incoming image).
//
// Once the playhead passes every card's end (narration can outlive the
// imagery), nothing matches and this returns null -- no stale highlight.
export function pickActiveCardBoxId(images, playheadSec) {
  if (!Array.isArray(images) || playheadSec == null || !Number.isFinite(playheadSec)) {
    return null;
  }
  let winnerBoxId = null;
  let winnerStart = -Infinity;
  images.forEach((img) => {
    const timing = img?.timing || {};
    const start = timing.startSec == null ? -Infinity : timing.startSec;
    const end = timing.endSec == null ? Infinity : timing.endSec;
    if (playheadSec >= start && playheadSec < end && start >= winnerStart) {
      winnerBoxId = img.boxId;
      winnerStart = start;
    }
  });
  return winnerBoxId;
}
